export const tokenAddress = '0x138208b7b77d34417a10acb57b05e627361915ff';
export const surveyorOFTAddress = '0x8120Ab4E904343B9A4311A41bb9970Cf903fc138';
export const surveyorProxyOFTAddress =
  '0x9FB6440B11eaeDdfD41216Da57935F5bC51235f6';

export const AVAX_CHAIN_ID = 43114;
export const ARBITRUM_CHAIN_ID = 42161;
export const LZ_ARBITRUM_ID = 110;
export const LZ_AVAX_ID = 106;
